// extracted by mini-css-extract-plugin
module.exports = {"root":"Dropzone_root__0hYWp","inner":"Dropzone_inner__oO2kR"};